import { Component, EventEmitter, inject, Input, Output } from '@angular/core'
import { SpinnerComponent } from '../spinner/spinner.component'
import { NgxFilesizeModule } from 'ngx-filesize'
import { MatTooltip } from '@angular/material/tooltip'
import { MatIcon } from '@angular/material/icon'
import { TranslateModule } from '@ngx-translate/core'
import { catchError, of, Subscription } from 'rxjs'
import { FileUploadType, UploadsService } from '../uploads.service'
import { ToastService } from '../toast.service'
import { LoggerService } from '../logger.service'
import { MatButton, MatIconButton } from '@angular/material/button'
import { DocumentUploadInfo, getFileExtension, getFileName } from '../utils'
import { FileValidationService } from '../file-validation.service'

@Component({
  selector: 'app-file-upload',
  standalone: true,
  imports: [SpinnerComponent, NgxFilesizeModule, MatTooltip, MatIcon, TranslateModule, MatIconButton, MatButton],
  templateUrl: './file-upload.component.html',
  styleUrl: './file-upload.component.scss',
})
export class FileUploadComponent {
  @Input({ required: true })
  acceptedFileTypes!: string[]

  @Input()
  maxSize: number | null = null

  @Input({ required: true })
  type!: FileUploadType

  @Output()
  fileChange = new EventEmitter<DocumentUploadInfo | null>()

  uploadsService = inject(UploadsService)
  toastService = inject(ToastService)
  loggerService = inject(LoggerService)
  fileValidationService = inject(FileValidationService)
  uploadSubscription: Subscription | null = null
  chosenFile: File | null = null
  isUploading = false

  fileInputChanged(fileInputEvent: any) {
    const chosenFile = fileInputEvent.target.files[0] ?? null
    if (chosenFile === null) {
      return
    }
    const fileIsValid = this.fileValidationService.validateFile(chosenFile, this.acceptedFileTypes, this.maxSize)
    if (!fileIsValid) {
      return
    }

    const extension = getFileExtension(chosenFile)
    this.chosenFile = chosenFile
    this.isUploading = true
    this.uploadSubscription = this.uploadsService
      .upload(this.type, this.chosenFile!)
      .pipe(
        catchError((error) => {
          this.toastService.show('CALLS.CALL_INFO.DOCUMENT_UPLOAD.UPLOAD_FAILED')
          this.loggerService.error('Error uploading file', error)
          this.isUploading = false
          this.chosenFile = null
          return of(null)
        })
      )
      .subscribe(async (uploadInfo) => {
        if (uploadInfo !== null && uploadInfo.uploadKey !== null) {
          this.fileChange.emit({ key: uploadInfo.uploadKey, extension: extension.toUpperCase(), fileName: getFileName(this.chosenFile!) })
          this.isUploading = false
        }
      })
  }

  removeFile() {
    this.chosenFile = null
    if (this.uploadSubscription) {
      this.uploadSubscription.unsubscribe()
      this.uploadSubscription = null
    }
    this.fileChange.emit(null)
  }

  get acceptedFileTypesString() {
    return this.acceptedFileTypes.map((fileType) => `.${fileType}`).join(',')
  }
}
